import React from 'react';
import PropTypes from 'prop-types';
import GlobalModal from 'components/modals/GlobalModal';
import ProductFilters from './ProductFilters';
import ProductTable from './ProductTable';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AddIcon } from 'assets/materialIcons/materialIcons';

class ProductModal extends React.Component {
    handleDialogSubmit = (productRelatedId) => {
        const { handleAdd } = this.props;

        handleAdd(productRelatedId);
    }

    render() {
        const {
            actionType,
            location,
            productId,
            resource,
            translate,
        } = this.props;

        const actions = [
            {
                label: translate('actions.goBack'),
                focus: true,
                primary: true,
            },
        ];

        return <GlobalModal
            button={ {
                icon: <AddIcon color={ theme.palette.doveGray } />,
                title: translate('actions.add'),
                primary: false,
            } }
            dialog={ {
                actions: actions,
                title: translate('resources.products.related.add'),
            } }
        >
            <ProductFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
            />

            <ProductTable
                productId= { productId }
                handleAdd={ (productRelatedId) => {
                    return this.handleDialogSubmit(productRelatedId);
                } }
            />
        </GlobalModal>;
    }
}

ProductModal.propTypes = {
    actionType: PropTypes.string.isRequired,
    handleAdd: PropTypes.func.isRequired,
    location: PropTypes.object,
    productId: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductModal);



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/ProductModal.js